import type { Stance } from "../api/types";

const STYLES: Record<Stance, string> = {
  bullish: "bg-emerald-500/15 text-emerald-300 ring-emerald-500/30",
  neutral: "bg-slate-500/15 text-slate-300 ring-slate-500/30",
  bearish: "bg-rose-500/15 text-rose-300 ring-rose-500/30",
};

export default function StanceBadge({ stance }: { stance: Stance }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide ring-1 ring-inset ${STYLES[stance]}`}
    >
      {stance}
    </span>
  );
}
